import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tercer-separador',
  templateUrl: './tercer-separador.component.html',
  styleUrls: ['./tercer-separador.component.css']
})
export class TercerSeparadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
